export const PRESENCE_EVENTS = ['pointerdown', 'pointermove', 'keydown', 'wheel', 'touchstart'] as const;
// Input inside a cross-origin iframe never reaches this window, so an embedding page that can tell its
// user acted (Reports, on Metabase navigation) raises this instead.
export const PRESENCE_SIGNAL_EVENT = 'cms-user-presence';
export const signalUserPresence = (): void => {
  window.dispatchEvent(new Event(PRESENCE_SIGNAL_EVENT));
};
export const ACTIVITY_REPORT_INTERVAL_MS = 60 * 1000;

const LAST_ACTIVITY_REPORT_KEY = 'cms_last_activity_report_at';
export const SESSION_EXPIRES_AT_KEY = 'cms_session_expires_at';

export const parsePositiveNumber = (value: string | null): number | null => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

const readNumber = (key: string): number | null => {
  try {
    return parsePositiveNumber(window.localStorage.getItem(key));
  } catch {
    return null;
  }
};

const writeNumber = (key: string, value: number): void => {
  try {
    window.localStorage.setItem(key, String(value));
  } catch {
    // Storage unavailable (private window, blocked site data): no cross-tab sharing, each tab throttles on its own.
  }
};

// Shared across the browser's CMS tabs, so one report a minute covers all of them.
export const getLastActivityReportAt = (): number | null => readNumber(LAST_ACTIVITY_REPORT_KEY);
export const setLastActivityReportAt = (timestampMs: number): void =>
  writeNumber(LAST_ACTIVITY_REPORT_KEY, timestampMs);

// Puts the shared report time back after a failed report, unless another tab has reported since.
export const restoreLastActivityReportAt = (failedReportAt: number, previousReportAt: number | null): void => {
  try {
    if (readNumber(LAST_ACTIVITY_REPORT_KEY) !== failedReportAt) {
      return;
    }
    if (previousReportAt === null) {
      window.localStorage.removeItem(LAST_ACTIVITY_REPORT_KEY);
    } else {
      window.localStorage.setItem(LAST_ACTIVITY_REPORT_KEY, String(previousReportAt));
    }
  } catch {
    // Storage unavailable: there is no shared time to put back.
  }
};

export const publishSessionExpiresAt = (sessionExpiresAt: number): void =>
  writeNumber(SESSION_EXPIRES_AT_KEY, sessionExpiresAt);
